export class UpdateWorkOrderDatumRequest {
  DatumName: string;
  DatumValue: string;
}
